import { CaretDownIcon, CaretUpIcon } from '@phosphor-icons/react'
import { State } from '@hookstate/core'
import {
  CollapsibleContainer,
  CollapsibleHeader,
  CollapsibleBody
} from './../../../metrics/infrastructure/slot-status/operation-models/partials.component'

type CollapsibleSubModuleProps = {
  title: string
  children?: React.ReactNode
  displayValues: State<{}, {}>
  collapsibleIndex: number
  initialState: { [key: number]: boolean }
}

const CollapsibleSubModule = ({
  title,
  children,
  displayValues,
  collapsibleIndex,
  initialState
}: CollapsibleSubModuleProps) => {
  return (
    <CollapsibleContainer aria-label='operating-model' large={true}>
      <CollapsibleHeader primaryColor={'#000000'} large={true} show={displayValues.get()[collapsibleIndex]}>
        <p>{title}</p>
        <div>
          {displayValues.get()[collapsibleIndex] ? (
            <CaretUpIcon onClick={() => displayValues.set(initialState)} />
          ) : (
            <CaretDownIcon
              onClick={() => {
                displayValues.set({ ...initialState, [collapsibleIndex]: true })
              }}
            />
          )}
        </div>
      </CollapsibleHeader>
      <CollapsibleBody show={displayValues.get()[collapsibleIndex]}>
        {displayValues.get()[collapsibleIndex] && children}
      </CollapsibleBody>
    </CollapsibleContainer>
  )
}

export { CollapsibleSubModule }
